<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <!--<el-input style="width:200px;"-->
            <!--placeholder="请输入内容"-->
            <!--prefix-icon="el-icon-search"-->
            <!--v-model="searchdata">-->
            <!--</el-input>-->
            <el-col :span="10">
              <span class="demonstration">开始日期</span>
              <el-date-picker style="width:150px" size="mini"
                              v-model="begindate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
              <span class="demonstration">结束日期</span>
              <el-date-picker style="width:150px" size="mini"
                              v-model="enddate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
              <el-input style="width:150px;margin-left:5px;"
                        placeholder="选商品" size="mini"
                        v-model="seedname" clearable
                        @click.native="showGoodDetailSel"
                        @clear="clearSeedCode">
              </el-input>
            </el-col>
            <el-button type="primary" size="mini" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>
            <el-dropdown style="margin-left: 20px" @command="handleDropCommand"  v-if="pandian" >
              <el-button type="warning" size="mini">盘点</el-button>
              <el-dropdown-menu slot="dropdown" style="font-size: larger">
                <el-dropdown-item command="len">盘点镜片数量</el-dropdown-item>
                <el-dropdown-item command="frame" v-if="useFrame()">盘点镜架数量</el-dropdown-item>
                <el-dropdown-item command="peijian">盘点辅料数量</el-dropdown-item>
                <el-dropdown-item command="lenqrcode" v-if="qrcodescan">扫码盘点镜片</el-dropdown-item>
                <el-dropdown-item command="lenprintcode" v-if="qrcodescan">盘盈镜片-打码</el-dropdown-item>
                <el-dropdown-item command="frameprintcode" v-if="qrcodescan">盘盈镜架-打码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(115)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column type="index" width="50" label="序号" align="center">
          </el-table-column>
          <el-table-column
            prop="physicalstore" :show-overflow-tooltip="true"
            align="left"
            header-align="center"
            label="名称" >
          </el-table-column>
          <el-table-column
            prop="physicalstorecode"
            align="left"
            header-align="center"
            label="编码" width="130">
          </el-table-column>
          <el-table-column
            align="center"
            label="盘点日期" width="130">
            <template slot-scope="scope">
              {{(scope.row.accdate || "").substring(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="erpserial"
            label="ERP核算编号"
            align="center"
            header-align="center"
            width="130">
          </el-table-column>
          <el-table-column
            prop="cangkuname"
            label="仓库"
            align="center"
            header-align="center"
            width="130">
          </el-table-column>
          <el-table-column
            prop="uname"
            label="姓名"
            align="center"
            width="80"
            text-align="center">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="left"
            header-align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="lookDetails(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
        <MakeInventoryEdit ref="MakeInventoryEdit" @bindGrid="bindGrid" :filltemplates="'10;20;30'"></MakeInventoryEdit>
        <MakeInventoryEdit ref="MakeInventoryEdit40" @bindGrid="bindGrid" :filltemplates="40"></MakeInventoryEdit>
        <MakeInventoryScanEdit ref="MakeInventoryScanEdit1" @bindGrid="bindGrid"></MakeInventoryScanEdit>
        <MakeInventoryFrameEdit ref="MakeInventoryFrameEdit" @bindGrid="bindGrid"></MakeInventoryFrameEdit>
        <MakeInventoryAdd ref="MakeInventoryAdd1" @bindGrid="bindGrid"></MakeInventoryAdd>
        <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
      </div>
    </el-col>
  </div>
</template>

<script>

  import {getListData} from '@/api/set/warehouse';

  import MakeInventoryEdit from './MakeInventoryEdit';
  import MakeInventoryAdd from './MakeInventoryAdd';
  import MakeInventoryScanEdit from './MakeInventoryScanEdit';
  import MakeInventoryFrameEdit from './MakeInventoryFrameEdit';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel';
  import {checkModuleRight} from '@/api/login'

  export default {
    name: 'MakeInventory',
    msg:'盘点单',
    data() {
      return {
        msg: 'Welcome to Your Vue.js Ap22p',
        dialogFormVisible: false,
        searchdata: "",
        qrcodescan:false,
        begindate: this.begindate,
        enddate: this.enddate,
        loading: true,
        status: "",
        seedcode: "",
        seedname: "",
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        dataname: "",
        pandian:false,
        seedgoods: '',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        controlData: {}
      }
    },
    props: {
      cangkucodes: {type: Array, default: () => []},
      cangkuname: {default: ""},
    },
    methods: {
      handleDropCommand(command) {
        switch (command) {
          case 'len':
            this.add();
            break;
          case 'peijian':
            this.$refs.MakeInventoryEdit40.initForm()
            this.$refs.MakeInventoryEdit40.show()
            break;
          case 'frame':
            this.addFrame(false);
            break;
          case 'lenqrcode':
            this.addScan();
            break;
          case 'lenprintcode':
            this.printScan();
            break;
          case 'frameprintcode':
            this.addFrame(true);
            break;
        }
      },
      useFrame(){
        if(localStorage.getItem("hpapi_usemodel")&&localStorage.getItem("hpapi_usemodel")=='noframe'){
          return false;
        }
        return true;
      },
      add() {
        this.$refs.MakeInventoryEdit.initForm()
        this.$refs.MakeInventoryEdit.show()
      },
      addScan(){
        this.$refs.MakeInventoryScanEdit1.initForm()
        this.$refs.MakeInventoryScanEdit1.show()
      },
      printScan() {
        this.$refs.MakeInventoryAdd1.initForm();
        this.$refs.MakeInventoryAdd1.show();
      },
      addFrame(scanAdd){
        this.$refs.MakeInventoryFrameEdit.initForm(scanAdd)
        this.$refs.MakeInventoryFrameEdit.show()
      },
      lookDetails(index, row) {
        if (row.physicalstorecode) {
          this.$refs.MakeInventoryEdit.initData(row, 1)
          this.$refs.MakeInventoryEdit.show()
        } else {//镜架没有商品编码
          this.$refs.MakeInventoryFrameEdit.initData(row, 1)
          this.$refs.MakeInventoryFrameEdit.show()
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      bindGrid() {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          begindate: this.begindate,
          enddate: this.enddate,
          seedcode: this.seedcode,
          cangkucodes: JSON.stringify(this.cangkucodes),
          formtype: 74,
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {
        this.qrcodescan = reponse.data.code == 0;
      });
      this.pandian=this.$checkRight("盘点库存");
      this.bindGrid();
    },
    components: {
      MakeInventoryEdit,
      MakeInventoryFrameEdit,
      MakeInventoryScanEdit,
      MakeInventoryAdd,
      JxcgooddetailSel
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventory.vue